import {
  IconDashboard, IconServer, IconRoute, IconPlayerPlay,
} from '@tabler/icons-react'

import { ArchbaseNavigationItem } from '@archbase/admin'

import DashboardView from '@views/dashboard/DashboardView'
import ApiClientsView from '@views/clients/ApiClientsView'
import RouteJobsView from '@views/jobs/RouteJobsView'
import OptimizationPlaygroundView from '@views/playground/OptimizationPlaygroundView'

import {
  HOME_ROUTE,
  CLIENTS_ROUTE,
  JOBS_ROUTE,
  PLAYGROUND_ROUTE,
} from './navigationDataConstants'

const rootRoute: ArchbaseNavigationItem = {
  label: 'Inicio',
  icon: <IconDashboard />,
  link: '/',
  category: 'home',
  color: '#339af0',
  component: <DashboardView />,
  showInSidebar: false,
  keepAlive: true,
}

const dashboardRoute: ArchbaseNavigationItem = {
  label: 'Dashboard',
  icon: <IconDashboard />,
  link: HOME_ROUTE,
  category: 'dashboard',
  color: '#339af0',
  component: <DashboardView />,
  showInSidebar: true,
  keepAlive: true,
}

const clientsRoute: ArchbaseNavigationItem = {
  label: 'API Clients',
  icon: <IconServer />,
  link: CLIENTS_ROUTE,
  category: 'admin',
  color: '#7950f2',
  component: <ApiClientsView />,
  showInSidebar: true,
  keepAlive: true,
}

const jobsRoute: ArchbaseNavigationItem = {
  label: 'Jobs',
  icon: <IconRoute />,
  link: JOBS_ROUTE,
  category: 'monitor',
  color: '#20c997',
  component: <RouteJobsView />,
  showInSidebar: true,
  keepAlive: true,
}

const playgroundRoute: ArchbaseNavigationItem = {
  label: 'Playground',
  icon: <IconPlayerPlay />,
  link: PLAYGROUND_ROUTE,
  category: 'tools',
  color: '#fd7e14',
  component: <OptimizationPlaygroundView />,
  showInSidebar: true,
  keepAlive: true,
}

export const navigationData: ArchbaseNavigationItem[] = [
  rootRoute,
  dashboardRoute,
  clientsRoute,
  jobsRoute,
  playgroundRoute,
]
